// Salesforce Connection Guide Alpine.js Component
// Handles copy-to-clipboard functionality for callback URL

document.addEventListener('alpine:init', () => {
  Alpine.data('salesforce_connection_guide', () => ({
    // Copy button state
    copied: false,
    copyError: false,
    
    // Copy callback URL to clipboard
    async copyCallbackUrl() {
      const urlElement = document.getElementById('callback-url');
      if (!urlElement) {
        console.error('Callback URL element not found');
        return;
      }
      
      const url = urlElement.textContent.trim();
      
      try {
        // Try modern clipboard API first
        if (navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(url);
          this.copied = true;
          this.copyError = false;
        } else {
          // Fallback to older method
          this.fallbackCopyToClipboard(url);
        }
        
        // Reset after 1 second
        setTimeout(() => {
          this.copied = false;
        }, 1000);
      } catch (err) {
        console.error('Failed to copy:', err);
        // Try fallback method
        this.fallbackCopyToClipboard(url);
      }
    },
    
    // Fallback copy method for older browsers or when clipboard API fails
    fallbackCopyToClipboard(text) {
      try {
        const textArea = document.createElement('textarea');
        textArea.value = text;
        textArea.style.position = 'fixed';
        textArea.style.left = '-999999px';
        textArea.style.top = '-999999px';
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        
        const successful = document.execCommand('copy');
        document.body.removeChild(textArea);
        
        if (successful) {
          this.copied = true;
          this.copyError = false;
          
          setTimeout(() => {
            this.copied = false;
          }, 1000);
        } else {
          this.copyError = true;
          console.error('Fallback copy failed');
        }
      } catch (err) {
        this.copyError = true;
        console.error('Fallback copy error:', err);
      }
    }
  }));
});
